import { connect } from 'react-redux'
import moment from 'moment'
import { Excel } from 'antd-table-saveas-excel'
import React, {useState, useEffect, useCallback, useLayoutEffect, useRef} from 'react'
import {
  Row,
  Col,
  Button,
  Select,
  Space,
  Tooltip,
  Divider,
  Spin,
  Form,
  Checkbox,
} from 'antd'
import visa_card from "../../../../../assets/images/visa_card.png";
import master_card from "../../../../../assets/images/master_card.png";
import TableComponent from 'components/Table'
import SearchableColumn from 'components/Table/ColumnSearch'
import SortableColumn from 'components/Table/ColumnSort'
import InputField from 'components/InputField'
import { BUTTONS, TemplateSalaryExcell } from 'constants/constants'
import JSZip from 'jszip'
import {
  SearchIco,
  PlusIco,
  DownloadIco,
  NorificationIco,
  ErrorNotificationIco,
  EditIco
} from '../../../../../modules/CustomIcons'
import {
  createTransferSalary, editTableDataSalary, getSalaryListFunc, getSalaryListWithPinFunc
} from 'store/actions/salary'
import { useHistory } from "react-router-dom";

import { getSalaryList } from '../../../../services/salary'
import { getCurrentCompany } from '../../../../services/user'
import './index.scss'
import '../../index.scss'
import '../Transfer/index.scss'
import '../../../Transfer/transfer.scss'
import { Spinner } from 'constants/constants'
import Item from 'antd/lib/list/Item'
import Modal from 'components/Modal'
import { financial, dateFormatter } from '../../../../services/helper'
import { useActions } from '../../../../hooks/useActions'
import CustomTooltip from 'components/Tooltip'
import XLSX from 'sheetjs-style';
import * as FileSaver from "file-saver";
import { useTranslation } from 'react-i18next'
import {getMessageLists} from "store/actions/home";
import { useConveyer } from "@egjs/react-conveyer";
const SALARY_TEMPLATE_FIRST_DATA_ROW = 7
const SALARY_TEMPLATE_LAST_ROW = 2000

function escapeSalaryTemplateText(value: string) {
  return value
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function setSalaryTemplateRowNumber(xml: string, ref: string, rowNumber: number) {
  const pattern = new RegExp(`<c r="${ref}"([^>]*)>([\\s\\S]*?)</c>`)
  return xml.replace(pattern, (match, attrs: string, inner: string) => {
    if (!/<v\s*\/>/.test(inner)) {
      return match
    }
    const cleanAttrs = attrs.replace(/\s+t="str"/, '')
    return `<c r="${ref}"${cleanAttrs}>${inner.replace(/<v\s*\/>/, `<v>${rowNumber}</v>`)}</c>`
  })
}

function fillSalaryTemplateCell(xml: string, ref: string, value: string, kind: 'text' | 'number') {
  if (value === '') {
    return xml
  }
  const pattern = new RegExp(`<c r="${ref}"([^>]*?)/>`)
  const match = xml.match(pattern)
  if (!match) {
    return xml
  }
  const attrs = match[1]
  const cell = kind === 'number'
    ? `<c r="${ref}"${attrs}><v>${value}</v></c>`
    : `<c r="${ref}"${attrs} t="inlineStr"><is><t xml:space="preserve">${escapeSalaryTemplateText(value)}</t></is></c>`
  return xml.replace(match[0], cell)
}

async function buildSalaryTemplate(rows: Array<{ employeeName: string, employeeAccount: string, employeeAmount: any, employeePmtDetail: string }>) {
  const binary = window.atob(TemplateSalaryExcell)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  const zip = await JSZip.loadAsync(bytes)
  const sheetFile = zip.file('xl/worksheets/sheet1.xml')
  if (!sheetFile) {
    return TemplateSalaryExcell
  }
  let sheet = await sheetFile.async('string')
  rows.forEach((row, index) => {
    const excelRow = SALARY_TEMPLATE_FIRST_DATA_ROW + index
    if (excelRow > SALARY_TEMPLATE_LAST_ROW) {
      return
    }
    const amount = row.employeeAmount === null || row.employeeAmount === undefined
      ? ''
      : String(row.employeeAmount).trim()
    sheet = setSalaryTemplateRowNumber(sheet, `D${excelRow}`, index + 1)
    sheet = fillSalaryTemplateCell(sheet, `E${excelRow}`, row.employeeName || '', 'text')
    sheet = fillSalaryTemplateCell(sheet, `F${excelRow}`, row.employeeAccount || '', 'text')
    if (/^\d+(\.\d*)?$/.test(amount)) {
      sheet = fillSalaryTemplateCell(sheet, `G${excelRow}`, String(Number(amount)), 'number')
    }
    sheet = fillSalaryTemplateCell(sheet, `H${excelRow}`, row.employeePmtDetail || '', 'text')
  })
  zip.file('xl/worksheets/sheet1.xml', sheet)
  const workbookFile = zip.file('xl/workbook.xml')
  if (workbookFile) {
    let workbook = await workbookFile.async('string')
    if (!workbook.includes('fullCalcOnLoad')) {
      workbook = workbook.replace('<calcPr ', '<calcPr fullCalcOnLoad="1" ')
    }
    zip.file('xl/workbook.xml', workbook)
  }
  return zip.generateAsync({ type: 'base64' })
}

const specialCharRegexRu = new RegExp('[а-яА-ЯЁё!@-]')
const specialCharRegex = new RegExp(
  /[`~!@#$%^&*_|«»+\-=?;:'"<>\{\}\[\]\\\/]/gi
)

const pageOptions = [10, 50, 100]

const SalaryList: React.FC<any> = ({ customerNo, salaryListCash, salaryListError, searchbyfin,messageList }) => {
  const {t} = useTranslation()
  const ref = useRef<HTMLDivElement>(null);
  useConveyer(ref, {
    horizontal: true,
  });
  const [form] = Form.useForm()
  const [pageSize, setPageSize] = useState(10)
  const [sort, handleSorter] = useState({})
  const [salaryList, setSalaryList] = useState([])
  const [selectedRowKeys, setCheckedList] = useState([])
  const [tableLoading, setTableLoading] = useState(Spinner)
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [filteredData, setFilteredData] = useState<[]>()
  const [filteredDataForSort, setFilteredDataForSort] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [notificationModal, setNotificationModal] = useState(false)
  const [createTransferData, setCreateTransferData] = useState<any>([{ key: 0, amount: "", description: "" }])
  const [createTransferOrDownloadExcel, setCreateTransferOrDownloadExcel] = useState("")
  const [isSalaryList, setIsSalaryList] = useState(false);
  const [current, setCurrent] = useState(1);
  const [isListButtonDisable, setIsListButtonDisable] = useState(false);
  const [isPinNotification, setIsPinNotification] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(0);
  const [textArray, setTextArray] = useState([])
  const language = localStorage.getItem("i18nextLng")

  const { createTransferSalary,getMessageLists, getSalaryListFunc, getSalaryListWithPinFunc } =
    useActions()

  let history = useHistory();

  const renderStatus = useCallback((statusType: string) => {
    switch (statusType) {
      case 'Active':
        return t("salary.active")
      case 'Blocked':
        return t("salary.blocked")
      case 'In process':
        return t("salary.inProcess")
      case 'Deactive':
        return t("businessCards.deactive")
      default:
        return null
    }
  }, [])

  const renderDate = useCallback((date) => {
    switch (date) {
      case moment(date).isAfter(moment(new Date()).format('DD.MM.YYYY')):
        return 'ordinary';
      case date.split('.')[1] == moment(new Date()).format('MM') && date.split('.')[2] == moment(new Date()).format('YYYYY'):
        return 'red';
      case moment(date).isBefore(moment(new Date()).format('DD.MM.YYYY')):
        return 'violet';
      default:
        return 'ordinary';
    }
  }, [salaryList]);



  useEffect(() => {
    const fetchessageData = async () => {
      let lang_text =  messageList?.result!== undefined ? (language=="az" ? messageList.result[23].textAZE :  language=="ru" ?
          messageList.result[23].textRU : language=="en" ?  messageList.result[23].textENG:""):"";
      const array =lang_text !==null  && lang_text !== undefined ? lang_text.split("|") : [];
      setTextArray(array);
    };



    fetchessageData();



  }, [messageList,language])


  const NumbersDropDown = () => {
    return(
        textArray.map((line:any,index:number) => {
          return (
              line.startsWith('http') ?
                  `<a href=${line} key=${index} > ${line} </a>`
                  :
                  `<p key=${index}> ${line} </p>`
          )

        }).join(''))
  }
  useEffect(() => {

    let salaryListArr: Array<any> = [];
    console.log(salaryListCash);
    (salaryListCash || []).forEach((item: any, index: number) => {
      salaryListArr.push({
        ind: index,
        key: index,
        owner: item.EmplName,
        iban: item.EmplIBAN,
        pin: item.EmplFIN ? item.EmplFIN : '',
        status: item.CardStat,
        deadline: item.ExpDate,
        pan: item.Pan,
        cardType: item.CardType
      });
    })
    setShowSpinner(false)

    setSalaryList(salaryListArr)
    if (salaryListArr.length === 0) {
      setIsSalaryList(true)
    } else {
      setIsSalaryList(false)
    }

    setIsListButtonDisable(true)
  }, [salaryListCash])

  const [filtereValues, setFilteredValues] = useState({
    col_2: '',
    col_3: '',
    col_4: '',
    col_5: '',
    col_6: '',
    col_7: '',
  })

  const handleFilterColumnSalary = (e: any, column: any) => {
    setIsPinNotification(false)
    let newfiltereValues = filtereValues
    if(e.target.value !== null && e.target.value !== undefined) {
      if (column === 'account') {
        newfiltereValues.col_2 = e.target.value?.toLowerCase()
        setFilteredValues(newfiltereValues)
      }

      if (column === 'iban') {
        newfiltereValues.col_3 = e.target.value?.toLowerCase()
        setFilteredValues(newfiltereValues)
      }

      if (column === 'fin') {
        newfiltereValues.col_4 = e.target.value?.toLowerCase()
        setFilteredValues(newfiltereValues)
      }

      if (column === 'cardStatus') {
        newfiltereValues.col_5 = e.target.value?.toLowerCase()
        setFilteredValues(newfiltereValues)
      }

      if (column === 'date') {
        newfiltereValues.col_6 = e.target.value?.toLowerCase()
        setFilteredValues(newfiltereValues)
      }

      if (column === 'pan') {
        newfiltereValues.col_7 = e.target.value?.toLowerCase()
        setFilteredValues(newfiltereValues)
      }
    }

    if (salaryList && filtereValues) {
      let filteredData

      filteredData = salaryList?.filter((sRow: any) => sRow?.owner?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_2"]) && sRow?.iban?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_3"]) && sRow?.pin?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]) && sRow?.status?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_5"]) && sRow?.deadline?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_6"]) && sRow?.pan?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_7"]));

      filteredData.map((item: any, i: number) => {
        return item.ind = i;
      })

      setIsFiltered(true)
      setFilteredData(filteredData)
      setFilteredDataForSort(filteredData)
    }
  }

  const columnsData = [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SortableColumn
            data={isFiltered ? filteredData : salaryList}
            setData={setFilteredData}
            dataOriginal={filteredDataForSort}
            setDataOriginal={setFilteredDataForSort}
            isFiltered={isFiltered}
            setIsFiltered={setIsFiltered}
            type={'index'}
            parameter={'ind'}
          />
          №
        </div>
      ),
      width: 60,
      ellipsis: true,
      editable: false,
      dataIndex: 'number',
      key: 'number',
      // sorter: (a: any, b: any) => a.key - b.key,
      render: (record: any, text: any, index: number) => {
        return <p style={{ textAlign: 'center' }}>{text.ind + 1}</p>
      },
    },
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Form form={form}>
            <SearchableColumn
              large
              title={t("salary.accountHolder")}
              form={form}
              name={'account'}
              filter={'searchfilter'}
              onChange={(event: any) =>
                handleFilterColumnSalary(event, 'account')
              }
              buttonClicked={buttonClicked}
              page={"salaryList"}
            />
          </Form>
        </div>
      ),
      dataIndex: 'owner',
      key: 'owner',
      width: 290,
      className: 'big-column',
      editable: false,
      ellipsis: true,
      render: (text: string) => {
        return text?.length > 30 ? (
          <CustomTooltip className="table-tooltip" title={text}>
            <p style={{ minWidth: 140, maxWidth: 330 }}>{text}</p>
          </CustomTooltip>
        ) : (
          <p style={{ minWidth: 140 }}>{text}</p>
        )
      },
    },
    {
      title: (
        <Form form={form}>
          <SearchableColumn
            large
            title={'İBAN'}
            form={form}
            name={'iban'}
            filter={'searchfilter'}
            onChange={(event: any) => handleFilterColumnSalary(event, 'iban')}
            buttonClicked={buttonClicked}
            page={"salaryList"}
          />
        </Form>
      ),
      dataIndex: 'iban',
      key: 'iban',
      editable: false,
      width: 260
    },
    {
      title: (
        <Form form={form} className="salaryListSpecial">
          <SearchableColumn
            large
            title={t("salary.FINCode")}
            form={form}
            name={'fin'}
            filter={'searchfilter'}
            onChange={(event: any) => handleFilterColumnSalary(event, 'fin')}
            buttonClicked={buttonClicked}
            page={"salaryList"}
          />
        </Form>
      ),
      dataIndex: 'pin',
      key: 'pin',
      editable: false,
      width: 100
    },
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SortableColumn
            data={isFiltered ? filteredData : salaryList}
            setData={setFilteredData}
            dataOriginal={filteredDataForSort}
            setDataOriginal={setFilteredDataForSort}
            isFiltered={isFiltered}
            setIsFiltered={setIsFiltered}
            type={'string'}
            parameter={'status'}
          />
          <Form form={form}>
            <SearchableColumn
              large
              title={t("salary.cardStatus")}
              form={form}
              name={'cardStatus'}
              filter={'searchfilter'}
              onChange={(event: any) =>
                handleFilterColumnSalary(event, 'cardStatus')
              }
              buttonClicked={buttonClicked}
              page={"salaryList"}
            />
          </Form>
        </div>
      ),
      dataIndex: 'status',
      key: 'status',
      render: (text: string) => {
        return (
          <p style={{ textAlign: 'center', position: 'relative', right: 25 }}>
            {renderStatus(text)} {text == 'Blocked' && <ErrorNotificationIco />}
          </p>
        )
      },
      // sorter: (a: string, b: string) => a.status.localeCompare(b.status),
    },
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <SortableColumn
            data={isFiltered ? filteredData : salaryList}
            setData={setFilteredData}
            dataOriginal={filteredDataForSort}
            setDataOriginal={setFilteredDataForSort}
            isFiltered={isFiltered}
            setIsFiltered={setIsFiltered}
            type={'date'}
            parameter={'deadline'}
          />
          <Form form={form}>
            <SearchableColumn
              large
              title={t("salary.expiryDate")}
              form={form}
              name={'date'}
              filter={'searchfilter'}
              onChange={(event: any) => handleFilterColumnSalary(event, 'date')}
              buttonClicked={buttonClicked}
              page={"salaryList"}
            />
          </Form>
          {/* <SearchableColumn title={t("salary.expiryDate")} /> */}
        </div>
      ),
      dataIndex: 'deadline',
      key: 'deadline',
      render: (text: string, record: any) => {

        let expire_date = dateFormatter(record.deadline, 'MMMM DD, YYYY HH:mm:ss', 'DD.MM.YYYY');
        const dateNow: Date = new Date();
        const dateExpire: Date = new Date(expire_date);
        let p_class = '';

        if (dateExpire < dateNow) {
          p_class = ' card_expired '
        } else if (
          parseInt(dateFormatter(record.deadline, 'M', 'DD.MM.YYYY')) === (dateNow.getMonth() + 1) &&
          parseInt(dateFormatter(record.deadline, 'YYYY', 'DD.MM.YYYY')) === dateNow.getFullYear()
        ) {
          p_class = ' card_expired_this_month '
        }

        return (
          <p className={p_class} >{record.deadline}</p>
        )
      }
      // sorter: (a, b) => moment(a.deadline, "DD.MM.YYYY").unix() - moment(b.deadline, "DD.MM.YYYY").unix(),
    },
    {
      title: (
        <Form form={form}>
          <SearchableColumn
            large
            title={'PAN'}
            form={form}
            name={'pan'}
            filter={'searchfilter'}
            onChange={(event: any) => handleFilterColumnSalary(event, 'pan')}
            buttonClicked={buttonClicked}
            page={"salaryList"}
          />
        </Form>
      ),
      dataIndex: 'pan',
      key: 'pan',
      className: 'big-column',
      render: (text: string, record: any) => {
        return <div>{record.cardType == 'Master'
          ? <img src={master_card} alt="master" /> : <img src={visa_card} style={{ maxWidth: 32, marginRight: 7 }} alt="visa" />}{text}</div>
      }
    },
  ]

  const columnsDataModal = [
    {
      title: t("common.amount"),
      dataIndex: 'amount',
      key: 'amount',
      editable: true,
      // placeholder: t("common.amount"),
      width: 80,
      maxWidth: 80,
      ellipsis: true,
      render: (text: string, record: any, index: string) => {
        let amountData
        let decimalPart = text && text.toString().split('.')[1]
        if (text !== '' && text !== undefined && text !== ' ') {
          amountData =
            !isNaN(text) &&
              text !== '' &&
              ((decimalPart && decimalPart.length < 3) || !decimalPart) ? (

              <div className="editable-cell-value-wrap__added editableCreateTransfer-form-item__added">
                <p className="editable-form-item__input editable-form-item__input--bordered">
                  {/* <p className="child_placeholder" style={{ maxWidth: 80 }}>

                </p> */}
                  {financial(text)}
                </p>
                <EditIco />
              </div>

            ) : (
              <div
                style={{ maxWidth: 80 }}
                className="editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary"
              >
                <p>{text !== '' ? financial(text) : ''}</p>
              </div>
            )
          return amountData
        } else {
          return (
            <div className="editable-cell-value-wrap__added editableCreateTransfer-form-item__added">
              <p className="editable-form-item__input editable-form-item__input--bordered">
                {/* <p className="child_placeholder" style={{ maxWidth: 80 }}>

                </p> */}
                {text}
              </p>
              <EditIco />
            </div>
          )
        }
      },
    },
    // {
    //   title: t("transfers.details"),
    //   dataIndex: 'description',
    //   key: 'description',
    //   editable: true,
    //   // placeholder: t("transfers.details"),
    //   width: 200,
    //   ellipsis: true,
    //   render: (text: string, record: any, index: string) => {
    //     // onlyLetters(text)
    //     if (text !== '' && text !== undefined) {
    //       return text ? (
    //         <div
    //           className={
    //             (text && text.length > 140) ||
    //               specialCharRegexRu.test(text) ||
    //               specialCharRegex.test(text)
    //               ? 'editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary'
    //               : 'editable-cell-value-wrap editable-cell-value-wrap__salary'
    //           }
    //         >
    //           {' '}
    //           {text?.length > 17 ? (
    //             <CustomTooltip title={text}>
    //               <p>{text}</p>
    //             </CustomTooltip>
    //           ) : (
    //             <p>{text}</p>
    //           )}
    //         </div>
    //       ) : (
    //         <div className="editable-cell-value-wrap--errored editable-cell-value-wrap--errored__salary">
    //           {text?.length > 17 ? (
    //             <CustomTooltip title={text}>
    //               <p>{text}</p>
    //             </CustomTooltip>
    //           ) : (
    //             <p>{text}</p>
    //           )}
    //         </div>
    //       )
    //     } else {
    //       return (
    //         <div className="editable-cell-value-wrap__added editableCreateTransfer-form-item__added">
    //           <p className="editable-form-item__input editable-form-item__input--bordered">
    //             {text}
    //           </p>
    //           <EditIco />
    //         </div>
    //       )
    //     }
    //   },
    // }
  ]

  const text = (
    <div className="ant-tooltip-inner__data">
      {t("salary.salaryListDesc")}
    </div>
  )
  const handleChange = (sorter: any) => {
    handleSorter(sorter)
  }

  function onSelectChange(checkedList: Array<String>) {
    //@ts-ignore
    setCheckedList(checkedList)
  }

  const fetchDataAccounts = async () => {
    if(salaryListError || searchbyfin) {
      // let cif= getCurrentCompany().customerNo

      setIsPinNotification(false)
      setInputValue("")
      setIsFiltered(false)
      setButtonClicked(buttonClicked + 1);

      form.setFieldsValue(
          {
            ["search_fin"]: "",
            ["account"]: "",
            ["iban"]: "",
            ["fin"]: "",
            ["cardStatus"]: "",
            ["date"]: "",
            ["pan"]: ""
          }
      );
      setShowSpinner(true)
      getSalaryListFunc(customerNo)
    }
    // let salaryList = await getSalaryList(customerNo)
  }
  // fetchDataAccounts()

  const handleFilterColumn = () => {

    // setIsPinNotification(true)
    // const filteredData = salaryList?.filter((item) => {
    //   //@ts-ignorets-ignore
    //   return item['pin'].toLowerCase().includes(inputValue.toLowerCase())
    // })
    //
    // filteredData.map((item: any, i: number) => {
    //   return item.ind = i;
    // })
    //
    // setFilteredData(filteredData)
    // setIsFiltered(true)
    // setFilteredDataForSort(filteredData)

    setIsPinNotification(false)
    setIsFiltered(false)
    // setButtonClicked(buttonClicked + 1);

    form.setFieldsValue(
        {
          ["account"]: "",
          ["iban"]: "",
          ["fin"]: "",
          ["cardStatus"]: "",
          ["date"]: "",
          ["pan"]: ""
        }
    );
    setShowSpinner(true)
    getSalaryListWithPinFunc(customerNo, inputValue);

  }

  // const downloadXls = () => {
  //   const excel = new Excel()
  //   excel
  //     .addSheet('test')
  //     .addColumns(columnsData)
  //     .addDataSource(salaryList, {
  //       str2Percent: true,
  //     })
  //     .saveAs('Excel.xlsx')
  // }

  function downloadExcel(fileName: string, fileBase64: string) {
    const linkSource = `data:application/vnd.ms-excel;base64,${fileBase64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  function exportListExcel() {

    const excelData: Array<any> = [];
    selectedRowKeys.map((item1: any) => {
      salaryList.map((item: any) => {
        if (item.key === item1) {
          excelData.push({
            "№": item.ind + 1,
            [t("salary.accountHolder")]: item.owner,
            "İBAN": item.iban,
            [t("salary.FINCode")]: item.pin,
            [t("salary.cardStatus")]: item.status,
            [t("salary.expiryDate")]: item.deadline,
            "PAN": item.pan
          })
        }
      })
    })

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    const fileExtension = ".xlsx";
    const fileName = "BR_emekdashlarin_siyahisi";
    var wscols = [
      { wch: 6 },
      { wch: 40 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 }
    ];

    const ws = XLSX.utils.json_to_sheet(excelData);
    ws['!cols'] = wscols;
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType })
    FileSaver.saveAs(data, fileName + fileExtension)
  }

  const handleInputChangeSave = (row: any) => {
    const newData = [...createTransferData]
    newData[0] = row
    setCreateTransferData(newData)
  }

  const handleInputChange = (e: any, dataIndex: string) => {
    // setCopiedData(e.target.value)
  }

  useEffect(()=>{
    editTableDataSalary([])
  },[])
  const onOkCreateTransfer = async () => {
    editTableDataSalary([])
    createTransferSalary([])
    if (createTransferOrDownloadExcel === "createTransfer") {
      let createTransferDataCollect: any = [];
      selectedRowKeys.map((item: any) => {
        if (isFiltered) {
          filteredData?.map((item2: any) => {
            if (item2.key === item) {
              createTransferDataCollect.push(
                {
                  iban: item2.iban,
                  amount: createTransferData[0].amount,
                  description: createTransferData[0].description,
                  owner:item2?.owner
                }
              )
            }
          })
        } else {
          salaryList?.map((item3: any) => {
            if (item3.key === item) {
              createTransferDataCollect.push(
                {
                  iban: item3.iban,
                  amount: createTransferData[0].amount,
                  description: createTransferData[0].description,
                  owner:item3?.owner
                }
              )
            }
          })
        }
      })
      createTransferSalary(createTransferDataCollect)
      setNotificationModal(false)
      history.push({ pathname: '/salary/transfer' })
    } else if (createTransferOrDownloadExcel === "downloadExcel") {

      let createTransferDataCollectForExcel: any = [];
      selectedRowKeys.map((item: any) => {
        if (isFiltered) {
          filteredData?.map((item2: any) => {
            if (item2.key === item) {
              createTransferDataCollectForExcel.push(
                {
                  employeeName: item2.owner,
                  employeeAccount: item2.iban,
                  employeeAmount: createTransferData[0].amount,
                  employeePmtDetail: createTransferData[0].description
                }
              )
            }
          })
        } else {
          salaryList?.map((item3: any) => {
            if (item3.key === item) {
              createTransferDataCollectForExcel.push(
                {
                  employeeName: item3.owner,
                  employeeAccount: item3.iban,
                  employeeAmount: createTransferData[0].amount,
                  employeePmtDetail: createTransferData[0].description
                }
              )
            }
          })
        }
      })


      const fileBase64 = await buildSalaryTemplate(createTransferDataCollectForExcel)
      downloadExcel('SalaryTemplate.xlsx', fileBase64)

      setNotificationModal(false)
    }
  }

  const onPageChange = (newPagination: any) => {
    setCurrent(newPagination)
  }
  const allRowKeys = (isFiltered ? filteredData : salaryList).map(
  (item: any) => item.ind
);
const rowSelection = {
  selectedRowKeys,
  onChange: (keys: React.Key[]) => {
    setCheckedList(keys);
  },
  columnTitle: (
    <Checkbox
      indeterminate={
        selectedRowKeys.length > 0 &&
        selectedRowKeys.length < allRowKeys.length
      }
      checked={
        allRowKeys.length > 0 &&
        selectedRowKeys.length === allRowKeys.length
      }
      disabled={allRowKeys.length === 0}
      onChange={(e) => {
        if (e.target.checked) {
          setCheckedList(allRowKeys);
        } else {
          setCheckedList([]);
        }
      }}
    />
  ),
};
  return (
    <div className='transfer_child_tabs' ref={ref}>
    <Spin {...tableLoading} spinning={showSpinner}>
      <Row>
        <Modal
          width={410}
          height={350}
          visible={notificationModal}
          title={t("salary.applyByList")}
          className="warning-modal notification-modal edit-modal"
          onOk={() => onOkCreateTransfer()}
          onCancel={() => setNotificationModal(false)}
        >
          <TableComponent
              className="transfers-createTransferTable"
              columns={columnsDataModal}
              data={createTransferData}
              handleInputChangeSave={handleInputChangeSave}
              handleInputChange={(e: any, dataIndex: string) =>
                  handleInputChange(e, dataIndex)
              }
          />
          <div className="notification_violet">
            <p>{t("salary.salaryListNotify")}</p>
          </div>
        </Modal>

        <Col span={24} style={{minWidth: "1446px"}}>
          <Col flex={'900px'} className="salary-transfer__table__divider">
            <div className="">
              <Row style={{ justifyContent: 'space-between' }}>
                <div>
                  <ul
                    className="d-flex employee-list"
                    style={{ marginLeft: 30 }}
                  >
                    <li>
                      <CustomTooltip
                          title={NumbersDropDown()}
                          overlayClassName="tabs_tooltip">
                        <Button
                          size={'small'}
                          className={(salaryListError || searchbyfin) ? "transfer__button list-btn-active" : "transfer__button list-btn" }
                          onClick={() => fetchDataAccounts()}
                          // disabled={!salaryListError}
                        >
                          {t("salary.getFullList")} <NorificationIco />
                        </Button>
                      </CustomTooltip>
                    </li>
                    <li>
                      <Space direction="vertical">
                        <div className="flex">
                          <Form form={form}>
                            <InputField
                              placeholder={t("salary.searchByFINCode")}
                              allowClear={true}
                              onChange={(e: any) => setInputValue(e.target.value)}
                              onBlur={(e) => setInputValue(e.target.value)}
                              maxLength={10}
                              className="not-required search-field"
                              required={false}
                              onlyEnglishAndNumber={true}
                              name={"search_fin"}
                              staticValue={true}
                              value={''}
                              form={form}
                            />
                          </Form>
                          <Col flex="40px" style={{ marginLeft: 10 }}>
                            <Button
                              size={'medium'}
                              icon={<SearchIco />}
                              onClick={handleFilterColumn}
                              id="circle-search"
                              className="blue-button transfer__button flex "
                            ></Button>
                          </Col>
                          {!showSpinner && searchbyfin && salaryList?.length == 0 && (
                            <span
                              style={{
                                color: ' #F3646C',
                                fontSize: 12,
                                width: 200,
                                marginTop: 6,
                              }}
                            >
                              {t("salary.infoFINnoFound")}
                            </span>
                          )}
                        </div>
                      </Space>
                    </li>
                  </ul>
                </div>
                <div className="flex pagination-selector">
                  <p>{t("salary.numberAtPage")} </p>
                  <Select
                    defaultValue={10}
                    style={{ position: 'relative', top: '5px' }}
                    onChange={(value) => setPageSize(value)}
                  >
                    {pageOptions.map((item) => {
                      return <option value={item}>{item}</option>
                    })}
                  </Select>
                </div>
              </Row>
            </div>
            <Divider />
          </Col>
          <TableComponent
            columns={columnsData}
            className="transfer-table transfers-table__component salary-table-select salary-table  home_account_table salary-table-only"
            data={isFiltered ? filteredData : salaryList}
            id="salary-list"
            rowSelection={rowSelection}
            scroll={{ x: 1000 }}
            pagination
            pageSize={pageSize}
            current={current}
            onChange={handleChange}
            onPageChange={onPageChange}
          />

          {
            isSalaryList ?
              <Row className='accountStatement-nodata-row' style={{ marginTop: "25px" }}>
                <Row className='accountStatement-nodata-row__text'>
                  {t("salary.noListEmployee")}
                </Row>
              </Row> : <></>
          }

          <div className="flex" style={{ float: 'right' }}>
            <div className="salary-btns salary-btns_list">
              <Button
                size={'large'}
                icon={<PlusIco />}
                disabled={(selectedRowKeys.length === 0) || (isFiltered ? filteredData?.length === 0 : null)}
                className="light-button refresh_btn"
                onClick={() => { setNotificationModal(true); setCreateTransferOrDownloadExcel("createTransfer") }}
              >
                {BUTTONS.CREATE_TRANSFER}
              </Button>
              {/*<a*/}
              {/*  href={`${window.location.href}/BR_Salary_templateALL.xls`}*/}
              {/*  download*/}
              {/*>*/}
              <Button
                size={'large'}
                htmlType="submit"
                disabled={(selectedRowKeys.length === 0) || (isFiltered ? filteredData?.length === 0 : null)}
                icon={<DownloadIco />}

                className="light-button refresh_btn"
                onClick={() => { setNotificationModal(true); setCreateTransferOrDownloadExcel("downloadExcel") }}

              >
                {BUTTONS.DOWNLOAD_PATTERN}
              </Button>
              {/*</a>*/}
              <Button
                size={'large'}
                htmlType="submit"
                onClick={() => exportListExcel()}
                disabled={(selectedRowKeys.length === 0) || (isFiltered ? filteredData?.length === 0 : null)}
                icon={<DownloadIco />}
                className="light-button refresh_btn"
              >
                {BUTTONS.DOWNLOAD_LIST}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Spin>
    </div>
  )
}
const mapDispatchToProps = {
  createTransferSalary,
  getSalaryListFunc,
  getSalaryListWithPinFunc,
  getMessageLists
}
const mapStateToProps = (state: any) => ({
  customerNo:
    state.user && state.user.companyData.result
      ? state.user.companyData.result.customerNo
      : getCurrentCompany().customerNo,
  salaryListCash: state.salary.salaryList,
  salaryListError: state.salary.salaryListError,
  searchbyfin: state.salary.searchbyfin,
  messageList: state.home.messageList,
})


export default connect(mapStateToProps, mapDispatchToProps)(SalaryList)
